import { render, staticRenderFns } from "./EditArt.vue?vue&type=template&id=0373e5dd&scoped=true&"
import script from "./EditArt.vue?vue&type=script&lang=ts&"
export * from "./EditArt.vue?vue&type=script&lang=ts&"
import style0 from "./EditArt.vue?vue&type=style&index=0&id=0373e5dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0373e5dd",
  null
  
)

export default component.exports